export default __webpack_public_path__ + "static/media/bg-masthead-3-800w.2ef6ab29.webp";